import React from 'react';
import x from '../../../images/Vector-x.png';
import AuthenticationWithClick from '../../../HOC/AuthenticationWithClick';
import {Tag} from '../../../configuration/index.config';
const BubbleBoxP = (props) => <p onClick={props.onClick} className={props.className} >{props.title}</p>;
const BubbleBoxImage = (props) => <img alt={props.alt} src={props.src} className={props.className} onClick={props.onClick}/>;
const BubbleBoxPWrapper = AuthenticationWithClick(BubbleBoxP);
const BubbleBoxImageWrapper = AuthenticationWithClick(BubbleBoxImage);

interface IProps{
    title:string,
    onDelete?: any,
    index: number,
    classNameDiv?: string,
    type?:string,
    openReplace?: (value, type) => void,
    userStore?: any,
    typeToggle?: string,
    isCorrect?: boolean
}
const BubbleBox = (props:IProps) => {
    const {title, onDelete, index, openReplace, type, userStore, typeToggle = 'ws_video_editprojectparams', classNameDiv = '', isCorrect = true} = props;
    const normalizedSting = () => (title.length > 40 ? title.slice(0, 40) + '...' : title);

    return (
        <div className={`${isCorrect ? 'box-bubbles' : 'box-bubbles-incorrect'} ${classNameDiv}`}>
            {userStore ? <BubbleBoxPWrapper
                onClick={() => openReplace && openReplace(title, type)}
                className={`${isCorrect ? 'bubbles-p' : 'bubbles-p-incorrect'}`}
                userStore={userStore}
                title={normalizedSting()}
                authenticationKey={typeToggle === Tag.CLASSIFICATION ? 'ws_video_editprojectparams' : 'ws_image_editProjectParams'}/>
                : <BubbleBoxP onClick={() => openReplace && openReplace(title, type)}
                    className={`${isCorrect ? 'bubbles-p' : 'bubbles-p-incorrect'}`}
                    userStore={userStore}
                    title={normalizedSting()} />}
            {userStore ? <BubbleBoxImageWrapper
                alt='close bubble'
                src={x}
                className='bubbles-x'
                onClick={() => onDelete && onDelete(index)}
                authenticationKey={typeToggle === Tag.CLASSIFICATION ? 'ws_video_editprojectparams' : 'ws_image_editProjectParams'}
                calssTYpe='dont_show'
                userStore={userStore}/>
                : <>{onDelete ? <BubbleBoxImage alt='close bubble'
                    src={x}
                    className='bubbles-x'
                    onClick={() => onDelete && onDelete(index)}
                    calssTYpe='dont_show' /> : <div />}</>}
        </div>
    );
};

export default BubbleBox;
